$(document).ready(function() {
    if($('.ifa-banner-countdown').length){
        function initializeCountdown() {
            var $countdownElement = $('.ifa-banner-countdown');
            var endTime = $countdownElement.data('countdown').replace(/-/g, "/");
            function updateCountdown() {
                var now = new Date(); 
                var nowUTC = now.toUTCString();
                var targetDate = new Date(endTime);
                var targetDateUTC = targetDate.toUTCString();
                var difference = Date.parse(targetDateUTC) - Date.parse(nowUTC);
                if (difference <= 0) {
                    $countdownElement.remove();
                } else {
                    var days = Math.floor(difference / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((difference % (1000 * 60)) / 1000);
                    
                    $countdownElement.find('.countdown-days .countdown-box').text(days);
                    $countdownElement.find('.countdown-hours .countdown-box').text(hours);
                    $countdownElement.find('.countdown-minutes .countdown-box').text(minutes);
                    $countdownElement.find('.countdown-seconds .countdown-box').text(seconds);
                }
            }
            setInterval(updateCountdown, 1000);
            updateCountdown();
        }
        
        initializeCountdown();
    }

    $('.ifa-titanium-wrapper').each(function(index){
        $(this).toggleClass('ifa-titanium--reverse', index % 2 === 1);
    });

    if($('.ifa-titanium-image-slider').length){
        $('.ifa-titanium-image-slider').flickity({
            cellAlign: 'center',
            contain: true,
            wrapAround: false,
            prevNextButtons: true,
            pageDots: false
        });
    }

    $(document).on('click', '.ifa-doctor-testimonial-item', function(){
        if($(window).width() < 769){
            return;
        }
        const index = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        $(`.testimonial-dot:eq(${index})`).addClass('active').siblings().removeClass('active');
    });

    $(document).on('click', '.testimonial-dot', function(){
        const index = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        $(`.ifa-doctor-testimonial-item:eq(${index})`).addClass('active').siblings().removeClass('active');
    });

    if($('.ifa-doctor-testimonial-list').length){
        const $testimonialLists = $('.ifa-doctor-testimonial-list');
        let testimonialResizeTimer;

        function initTestimonialCarousel(){
            const useCarousel = window.matchMedia('(max-width: 1100px)').matches;

            $testimonialLists.each(function(){
                const $list = $(this);
                const hasMultipleCards = $list.children('.ifa-doctor-testimonial-item').length > 1;
                const instance = $list.data('flickity');

                if(useCarousel && hasMultipleCards && !instance){
                    $list.flickity({
                        cellAlign: 'center',
                        wrapAround: false,
                        prevNextButtons: false,
                        pageDots: true,
                        groupCells: true,
                        draggable: true
                    });
                } else if(!useCarousel && instance){
                    $list.flickity('destroy');
                }

                if(useCarousel && $list.data('flickity')){
                    window.requestAnimationFrame(function(){
                        $list.flickity('resize');
                    });
                }
            });
        }

        function initTestimonialAccordion(){
            if($(window).width() <= 1100){
                return;
            }

            $testimonialLists.each(function(){
                const $list = $(this);
                const $cards = $list.children('.ifa-doctor-testimonial-item');
                const collapsedCards = Math.max($cards.length - 1, 0);
                const activeWidth = Math.max(180, $list.width() - collapsedCards * (180 + 12));

                $list.css('--ifa-doctor-active-width', activeWidth + 'px');
                $cards.each(function(){
                    const $card = $(this);
                    const photoWidth = $card.children('.ifa-doctor-photo').length ? 180 : 0;
                    $card.find('.ifa-doctor-info').css('min-width', Math.max(0, activeWidth - photoWidth));
                });

                let tallest = 0;
                $cards.each(function(){
                    tallest = Math.max(tallest, $(this).find('.ifa-doctor-info-inner').outerHeight() || 0);
                });
                $cards.outerHeight(tallest);
            });
        }

        initTestimonialCarousel();
        initTestimonialAccordion();
        $(window).on('resize.ifaTestimonials', function(){
            clearTimeout(testimonialResizeTimer);
            testimonialResizeTimer = setTimeout(function() {
                initTestimonialCarousel();
                initTestimonialAccordion();
            }, 200);
        });
    }

    $(document).on('click', '.video-popup-trigger', function(e){
        e.preventDefault();
        const videoId = $(this).data('video');
        const videoEl = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoId + '?loop=1&autoplay=1&mute=1&playlist=' + videoId + '&iv_load_policy=3&disablekb=1&controls=0&playsinline=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        $('.video-popup .popup-video').empty().html(videoEl);
        $('.video-popup').addClass('active');
    });
    $(document).on('click', '.video-popup .popup-overlay,.video-popup .popup-close', function() {
        $('.video-popup').removeClass('active');
        $('.video-popup .popup-video').empty();
    });

    if($('.ifa-events-slider').length){
        $('.ifa-events-slider').each(function(){
            const $slider = $(this);
            if($slider.children('.ifa-event').length > 1 && !$slider.data('flickity')){
                $slider.flickity({
                    cellAlign: 'center',
                    wrapAround: true,
                    pageDots: true,
                    imagesLoaded: true
                });
            }
        });
    }

  $(document).on('click','.klaviyo-popup-trigger', function(e){
    e.preventDefault();
    const klaviyo_code = $(this).attr('data-klaviyo');
     window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', klaviyo_code]);
  })
});
